<template>
  <div class="labeled-text-input">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <TextInput
      ref="textInput"
      :id="inputId"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :is-read-only="isReadOnly"
      :formatter="formatter"
      :unformatted-on-focus="unformattedOnFocus"
      :mask="mask"
      :mask-pattern="maskPattern"
      :limit="limit"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </TextInput>
  </div>
</template>

<script>
import InputLabel from '../label';
import TextInput from '../text-input';
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'password'].includes(value)
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    formatter: {
      type: [Function, Object],
      default: null
    },
    unformattedOnFocus: {
      type: Boolean,
      default: false
    },
    mask: {
      type: [String, Function, Boolean],
      default: null
    },
    maskPattern: {
      type: RegExp,
      default: null
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      inputId: `input-text-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, TextInput },
  computed: {
    getTextInput() {
      return this.$refs.textInput;
    }
  },
  methods: {
    generateRandomId,
  },
};
</script>
